(function () {
  'use strict';
  if (window.__raPurchaseStackV1) return;
  window.__raPurchaseStackV1 = true;

  function money(cents) {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(cents / 100);
  }

  function selectedItems(root) {
    var items = [];
    String(root.dataset.fixedVariants || '').split(',').forEach(function (value) {
      var id = Number(value || 0);
      if (id && !items.some(function (item) { return item.id === id; })) items.push({ id: id, quantity: 1 });
    });
    var currentId = Number(root.dataset.currentVariant || 0);
    var formId = root.dataset.productFormId;
    if (formId) {
      var form = document.getElementById(formId);
      var selected = form && form.querySelector('input[name="id"]');
      if (selected && Number(selected.value)) currentId = Number(selected.value);
    }
    if (root.dataset.includeCurrent === 'true' && currentId) {
      items.push({ id: currentId, quantity: 1 });
    }
    root.querySelectorAll('.ra-stack-check input:checked').forEach(function (input) {
      var id = Number(input.dataset.variantId || 0);
      if (id && !items.some(function (item) { return item.id === id; })) {
        items.push({ id: id, quantity: 1 });
      }
    });
    return items;
  }

  function selectedTotal(root) {
    var total = String(root.dataset.fixedPrices || '').split(',').reduce(function (sum, value) {
      return sum + Number(value || 0);
    }, 0);
    total += root.dataset.includeCurrent === 'true' ? Number(root.dataset.currentPrice || 0) : 0;
    root.querySelectorAll('.ra-stack-check input:checked').forEach(function (input) {
      total += Number(input.dataset.price || 0);
    });
    return total;
  }

  function sync(root) {
    var button = root.querySelector('.ra-routine-add');
    if (!button) return;
    var count = selectedItems(root).length;
    var price = button.querySelector('[data-ra-total]');
    if (price) price.textContent = money(selectedTotal(root));
    button.disabled = count === 0;
    button.setAttribute('aria-disabled', String(count === 0));
  }

  async function add(root) {
    var button = root.querySelector('.ra-routine-add');
    var status = root.querySelector('.ra-stack-status');
    var items = selectedItems(root);
    if (!button || !items.length) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) status.textContent = '';
    try {
      var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      });
      var payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || 'This routine could not be added.');
      window.location.assign(window.Shopify.routes.root + 'cart');
    } catch (error) {
      if (status) status.textContent = error.message || 'This routine could not be added. Please try again.';
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }

  function init(root) {
    if (!root || root.dataset.raReady === 'true') return;
    root.dataset.raReady = 'true';
    root.querySelectorAll('.ra-stack-check input').forEach(function (input) {
      input.addEventListener('change', function () { sync(root); });
    });
    var button = root.querySelector('.ra-routine-add');
    if (button) button.addEventListener('click', function () { add(root); });
    sync(root);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ra-purchase-stack]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
/* ra-renderer-baseline-reconcile-v1-20260729 */
